import type React from 'react'

import type { ChromeFrame } from '../helpers/chrome-frame-of'

/** The dashed outline marking a frame as a link target during a linking session. */
export function LinkTargetOutline({
  chrome,
  inset,
  isHover,
}: {
  chrome: ChromeFrame
  /** Gap between the frame's edge and the outline, in screen px. */
  inset: number
  /** The pointer is over this target — solid, heavier and darker. */
  isHover: boolean
}): React.JSX.Element {
  return (
    <rect
      x={chrome.x - inset}
      y={chrome.y - inset}
      width={chrome.width + inset * 2}
      height={chrome.height + inset * 2}
      fill="none"
      stroke={isHover ? '#3B82F6' : '#93C5FD'}
      strokeDasharray={isHover ? undefined : '4 3'}
      strokeWidth={isHover ? 2 : 1}
      // Zoom-invariant, matching the port squares' convention: the stroke holds a
      // constant on-screen width via `non-scaling-stroke`, and the `inset` is a
      // screen-px value converted to doc px, so neither the border nor its gap from the
      // frame grows as the user zooms in (WMPCM-9868).
      //
      // Deliberately NOT paired with `shape-rendering="crispEdges"`: that snaps to the
      // SVG's own pre-transform grid, which fights the devicePixelRatio grid
      // non-scaling-stroke content actually rasterises on, and edges vanish or double at
      // specific zoom levels. See the Anti-Patterns table in `larry-frontend-ui/CLAUDE.md`.
      vectorEffect="non-scaling-stroke"
      style={{ pointerEvents: 'none' }}
      aria-hidden="true"
    />
  )
}
